import { startCase, toLower } from "lodash";

export function toTitleCase(s: string) {
  return startCase(toLower(s))
}

export function humanize(s: string) {
  return s.replace('_', ' ')
}
